const GLASSBOX_RETRY_INTERVAL_MS = 200;
const GLASSBOX_MAX_RETRY_ATTEMPTS = 10;
const ACTIVE_ACCOUNT_KEY = 'csa.glassbox.activeAccount';

const tryInvalidateGlassboxSession = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const detector = window._detector;
    if (
      detector &&
      typeof detector.isRecording === 'function' &&
      detector.isRecording() &&
      typeof detector.invalidateSession === 'function'
    ) {
      detector.invalidateSession();
      return true;
    }
  } catch {
    return false;
  }

  return false;
};

const invalidateGlassboxSession = (): void => {
  let attempt = 0;

  const run = () => {
    if (tryInvalidateGlassboxSession()) {
      return;
    }

    attempt += 1;
    if (attempt >= GLASSBOX_MAX_RETRY_ATTEMPTS) {
      return;
    }

    setTimeout(run, GLASSBOX_RETRY_INTERVAL_MS);
  };

  run();
};

export const syncGlassboxAccount = (accountNumber?: string | number | null): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const nextAccountNumber = String(accountNumber || '').trim();

  if (!nextAccountNumber) {
    return;
  }

  try {
    const activeAccountNumber = sessionStorage.getItem(ACTIVE_ACCOUNT_KEY) || '';

    if (nextAccountNumber === activeAccountNumber) {
      return;
    }

    sessionStorage.setItem(ACTIVE_ACCOUNT_KEY, nextAccountNumber);

    if (!activeAccountNumber) {
      return;
    }

    invalidateGlassboxSession();
  } catch {
    return;
  }
};
